import * as React from "react";
const InfoIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M12 9.858a1.111 1.111 0 1 0 0-2.222 1.111 1.111 0 0 0 0 2.222Zm.924 1.934v3.662a.924.924 0 0 1-1.849 0v-3.662a.924.924 0 0 1 1.85 0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm4.651 12.651a6.578 6.578 0 1 1-9.302-9.302 6.578 6.578 0 1 1 9.302 9.302Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm4.651 12.651a6.578 6.578 0 1 1-9.302-9.302 6.578 6.578 0 1 1 9.302 9.302Z"
}));
export default InfoIcon;